import { Injectable } from '@angular/core';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../../../../../common/services';
import { AllocationViewCoupleActionService } from './allocation-view-couple-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import {
  AllocationViewCoupleAction,
  AllocationViewCoupleSetInitialState,
} from './allocation-view-couple-action.actions';

export interface AllocationViewCoupleActionStateModel {
  loaded: boolean;
}

const initialState: AllocationViewCoupleActionStateModel = {
  loaded: false,
};

@State({
  name: 'allocationViewActionsCouple',
  defaults: initialState,
})
@Injectable()
export class AllocationViewCoupleActionState extends AllocationViewActionBaseState {
  static getLoaded(state: AllocationViewCoupleActionStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private allocationViewCoupleActionService: AllocationViewCoupleActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewCoupleAction)
  couple(
    ctx: StateContext<AllocationViewCoupleActionStateModel>,
    { payload: { identifier } }: AllocationViewCoupleAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewCoupleActionService.couple(identifier).pipe(
      map(() => {
        ctx.patchState({ loaded: true });
        this.finishAction('api.uli.success.couple');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewCoupleSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewCoupleActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
